import { gmnRoutes } from '@/core/router';
import { Header, Sidebar } from '@/shared/components/layout';
import '@/shared/components/layout';
import { Outlet } from 'react-router-dom';
import { SidebarInset, SidebarProvider } from '@/shared/components/ui';

export function GmnLayout() {
  return (
    <SidebarProvider>
      <Sidebar routes={gmnRoutes} />
      <SidebarInset>
        <Header routes={gmnRoutes} />
        <main className="flex flex-1 flex-col gap-4 p-6 pt-3 space-y-6">
          <div className="w-full max-w-full mx-auto pt-3 space-y-6">
            <Outlet />
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
